import { forwardRef } from 'react';

import { IconProps } from '.';

export const ArrowLongUpIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M9.54922 3.02078L4.74922 7.81078C4.63502 7.92677 4.57101 8.08301 4.57101 8.24578C4.57101 8.40856 4.63502 8.5648 4.74922 8.68078L5.47922 9.40078C5.59642 9.51265 5.75221 9.57507 5.91422 9.57507C6.07624 9.57507 6.23203 9.51265 6.34922 9.40078L8.85922 6.93078L8.85922 16.4108C8.86181 16.6089 8.94166 16.7982 9.08176 16.9382C9.22185 17.0783 9.41111 17.1582 9.60922 17.1608L10.3492 17.1608C10.5473 17.1582 10.7366 17.0783 10.8767 16.9382C11.0168 16.7982 11.0966 16.6089 11.0992 16.4108L11.0992 6.93078L13.6092 9.44078C13.7264 9.55265 13.8822 9.61507 14.0442 9.61507C14.2062 9.61507 14.362 9.55265 14.4792 9.44078L15.2092 8.72078C15.3234 8.6048 15.3874 8.44856 15.3874 8.28578C15.3874 8.12301 15.3234 7.96677 15.2092 7.85078L10.4092 3.02078C10.3533 2.96333 10.2865 2.91766 10.2126 2.88648C10.1387 2.8553 10.0594 2.83923 9.97922 2.83923C9.89905 2.83923 9.8197 2.8553 9.74584 2.88648C9.67199 2.91766 9.60513 2.96333 9.54922 3.02078Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default ArrowLongUpIcon;
